.list {
  margin: 0 calc(-2 * var(--space-xs));
  padding: var(--space-xs);
  transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out;
  border-radius: var(--border-radius-s);

  .isCompact {
    border-radius: var(--border-radius-xs);
  }
}

.isOver {
  background: rgb(var(--color-svp-grey), 0.3);
}

.item {
  transition: background 0.15s ease-in-out;
  min-height: 40px;
  padding: var(--space-xs);
  border-radius: var(--border-radius-s);

  .isCompact {
    padding: 0;
    border-radius: var(--border-radius-xs);
  }

  &.isDragged {
    background: rgb(var(--color-svp-grey), 0.3);
  }
}

.isDisabled {
  opacity: 0.5;
  pointer-events: none;
}
